// 공통 Status 타입 정의
export interface Status {
  title: string;
  className: string;
}

// Contact Grid Status (ManageContacts, Dashboard 등에서 사용)
export const contactGridStatus: Record<string, Status> = {
  IDLE:        { title: 'Idle',      className: 'bg-white border-black text-black' },
  COMPLETED:   { title: 'Done',      className: 'bg-[#DBF8E3] border-[#028E08] text-[#05870A]' },
  SCHEDULED:   { title: 'Scheduled', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
  IN_PROGRESS: { title: 'In Progress', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  CANCELLED:   { title: 'Cancel',    className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  CANCEL:      { title: 'Cancel',    className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  FAILED:      { title: 'Fail',      className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  UNKNOWN:     { title: 'Unknown',   className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  PROCESS:     { title: 'Process',   className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  COMPLETE:    { title: 'Done',  className: 'bg-[#DBF8E3] border-[#028E08] text-[#05870A]' },
  FAIL:        { title: 'Fail',      className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
};

// Payment Status (ManageContacts, MyPage 등에서 사용)
export const paymentStatus: Record<string, Status> = {
  paymentCompleted: { title: 'Complete', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  paymentPending: { title: 'Pending', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
}

// Cancel Status (ManageContacts, ManageSchedule 등에서 사용)
export const cancelStatus: Record<string, Status> = {
  Cancel: { title: 'Cancel', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  Toberefunded: { title: 'To be refunded', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  Refunded: { title: 'Refunded', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]'  },
  None: { title: 'None', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  CANCELLED: { title: 'Cancelled', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  TO_BE_REFUNDED: { title: 'To be refunded', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  REFUNDED: { title: 'Refunded', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  NONE: { title: 'None', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
};

// Cancelable Status (ManageContacts, ManageSchedule 등에서 사용)
export const cancelable: Record<string, Status> = {
  Cancel: { title: 'Cancel', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
};

// Schedule Status (ManageSchedule에서 사용)
export const scheduleStatus: Record<string, Status> = {
  IDLE:        { title: 'Idle',      className: 'bg-white border-black text-black' },
  COMPLETED:   { title: 'Done',      className: 'bg-[#DBF8E3] border-[#028E08] text-[#05870A]' },
  SCHEDULED:   { title: 'Scheduled', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
  IN_PROGRESS: { title: 'In Progress', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  CANCELLED:   { title: 'Cancel',    className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  CANCEL:      { title: 'Cancel',    className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  FAILED:      { title: 'Fail',      className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  UNKNOWN:     { title: 'Unknown',   className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  PROCESS:     { title: 'Process',   className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  COMPLETE:    { title: 'Done',  className: 'bg-[#DBF8E3] border-[#028E08] text-[#05870A]' },
  FAIL:        { title: 'Fail',      className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
}; 